module.exports = __webpack_public_path__ + "img/card-btn-3.432e119c.png";